export const SEGMENT_ERROR_SHOW_TABS = ['general'] as const;

export type SegmentErrorShowTab = (typeof SEGMENT_ERROR_SHOW_TABS)[number];

export const SEGMENT_ERROR_DEFAULT_TAB: SegmentErrorShowTab = 'general';
